<!-- laas-editor.component.html -->
<p-editor
  [(ngModel)]="value"
  [readonly]="readonly"
  [style]="style"
  (onInit)="onEditorInit($event)"
  (onTextChange)="onEditorChange($event)">
  <ng-template pTemplate="header">
    <span class="ql-formats">
      <select class="ql-size" [title]="'Common.Editor.FontSize' | translate">
        <option *ngFor="let size of fontSizes" [value]="size">{{ size }}</option>
      </select>
      <select class="ql-font" [title]="'Common.Editor.Font' | translate">
        <option *ngFor="let font of fonts" [value]="font.value">{{ font.label | translate }}</option>
      </select>
    </span>
    <span class="ql-formats">
      <button class="ql-bold" [title]="'Common.Editor.Bold' | translate"></button>
      <button class="ql-italic" [title]="'Common.Editor.Italic' | translate"></button>
      <button class="ql-underline" [title]="'Common.Editor.Underline' | translate"></button>
      <button class="ql-strike" [title]="'Common.Editor.Strike' | translate"></button>
    </span>
    <span class="ql-formats">
      <select class="ql-color" [title]="'Common.Editor.Color' | translate"></select>
      <select class="ql-background" [title]="'Common.Editor.Background' | translate"></select>
    </span>
    <span class="ql-formats">
      <button class="ql-list" value="ordered" [title]="'Common.Editor.OrderedList' | translate"></button>
      <button class="ql-list" value="bullet" [title]="'Common.Editor.BulletList' | translate"></button>
      <select class="ql-align" [title]="'Common.Editor.Align' | translate">
        <option selected></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
      </select>
    </span>
    <span class="ql-formats">
      <button class="ql-link" [title]="'Common.Editor.Link' | translate"></button>
      <button class="ql-image" [title]="'Common.Editor.Image' | translate"></button>
    </span>
    <span class="ql-formats">
      <button class="ql-clean" [title]="'Common.Editor.Clean' | translate"></button>
    </span>
  </ng-template>
</p-editor>

<input
  #fileInput
  type="file"
  accept="image/*"
  style="display: none"
  (change)="onFileSelected($event)">
